(function () {
  function update() {
    if (!document.body.classList.contains('is-home')) return;
    document.body.classList.toggle('scrolled', window.scrollY > 10);
  }

  document.addEventListener('DOMContentLoaded', function () {
    update();
    window.addEventListener('scroll', update, { passive: true });
  });

  // Theme editor events
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:select', update);
  document.addEventListener('shopify:section:deselect', update);
  document.addEventListener('shopify:section:reorder', update);
  document.addEventListener('shopify:section:unload', update);
})();